import React, { useEffect, useRef, useState } from 'react';
import OtpInput from '../OTPInput';
import { Col, Row } from 'react-awesome-styled-grid';
import styled from 'styled-components';
import { up } from 'styled-breakpoints';
import { P1, P2, H6, Modal, ModalFooterWithConfirmation, SelectDropdown, Input } from 'pfm-ui-components';

import { pxToRem } from '../../../styles/utils';
import * as constants from '../../../constants/OtpModal';
import { OTP_TIME_DURATION, NUM_OF_OTP_INPUTS } from '../../../constants/common';
import Timer from '../../common/Timer';
import { dropDownStyling, inputStylingProps } from '../../../styles/common';
import { formatMoney } from '../../../utils/calculations';
import { formatValueForDropDown } from '../../../utils/common';
import { CUSTOMER_SELECTS_BANK_ACCOUNT_WHICH_DOESNT_HAVE_ENOUGH_BALANCE } from '../../../constants/ErrorMessages';
import { useDeviceType } from '../../../utils/deviceType';
import DEVICE_TYPE from '../../../constants/device';

interface VerifyOTPModalProps {
  isOpen: boolean; // To display/hide modal
  closeModal: Function; // Action to perform when modal is close
  userDetails: UserData; // Customer details of bank accounts linked
  onConfirmedClicked?: Function; // Action to perform when the confirmed button is clicked
  isTransactionDone?: boolean; // To check Whether it's a bank transaction OTP or just mobile verification OTP
  className?: string;
  userFlow?: string;
  onResendCode?: Function;
  formik?: any;
  onHandleChange?: Function;
  selectedBankAccId?: string;
  showOtpField?: boolean;
  showLoader?: boolean;
  isBankBalanceInsufficientForTransaction?: boolean;
  clearOtp?: boolean;
  isTransactInvestJourney?: boolean;
  isCustomerMinor?: boolean; // field to check whether account is minor or not.
}

interface UserData {
  bankAccountNumbers?: Array<BankAccountLabelValue>; // array of bank account details object
  balance?: string; // array of bank account details object
  mobileNumber: string; // mobile number of the user
  countryCode?: string; // country code
  emailId?: string; // email address
}

interface BankAccountLabelValue {
  label: string;
  value?: string;
}

export default function VerifyOTPModal(props: VerifyOTPModalProps) {
  const {
    isOpen,
    closeModal,
    userFlow,
    onConfirmedClicked,
    userDetails,
    isTransactionDone,
    onResendCode,
    formik,
    onHandleChange,
    isTransactInvestJourney,
    selectedBankAccId,
    showOtpField,
    showLoader,
    isBankBalanceInsufficientForTransaction,
    clearOtp,
    isCustomerMinor,
  } = props;

  const ref = React.createRef();
  // const [dropdownValue, setDropdownValue] = useState(userDetails.bankAccountNumbers[0].value);
  const [selectedAcctId, setSelectedAcctId] = useState(selectedBankAccId);
  const [otp, setOTP] = useState('');
  const [clearOtpField, setClearOtpField] = useState(false);
  const inputAmountRef = useRef();
  const isMobile = useDeviceType() === DEVICE_TYPE.MOBILE;
  const onFocus = (event) => {};

  const handleOTPChange = (event) => {
    //Disable input when input amount greater than 9 digits
    if (event.target.value.length > 6) {
      event.target.value = event.target.value.substring(0, 6);
    }
    //Disable user from entering NaN, special characters and alphabets
    event.target.value = event.target.value.replace(/[^0-9]/g, '');
    setOTP(event.target.value)
  };

  const onModalClose = () => {
    setOTP('');
    closeModal();
  };

  const clearOtpOnClickResendCode = () => {
    setClearOtpField(!clearOtpField);
    setOTP('');
  };

  useEffect(() => {
    setClearOtpField(!clearOtpField);
    setOTP('');
  }, [clearOtp]);

  const Header = () => (
    <div>
      <StyledH6>{constants.VERIFY_OTP}</StyledH6>
    </div>
  );
  const Footer = () => (
    <FooterContainer>
      <div style={{marginTop: '-20px'}}>
      <ModalFooterWithConfirmation
        confirmMessage={constants.SUBMIT}
        shouldShowCancel={false}
        onClose={() => onModalClose()}
        onDone={() => onConfirmedClicked(otp)}
        className="otp-verification-modal"
        disable={isBankBalanceInsufficientForTransaction || otp.length !== NUM_OF_OTP_INPUTS}
        loader={showLoader}
      />
      </div>
      {!showLoader && (
        <ResentCodeWrapper>
          <Timer
          userFlow={userFlow}
            onResendCode={() => {
              onResendCode(clearOtpOnClickResendCode);
              clearOtpOnClickResendCode();
            }}
            timerDuration={OTP_TIME_DURATION}
          />
        </ResentCodeWrapper>
      )}
    </FooterContainer>
  );
  const inputRef = React.createRef();

  const OTPMessageContent = () => {
    if (isCustomerMinor) {
      return (
        <OTPLongMessage>Enter the 6-digit code sent to your registered mobile no. <OTPMessage>{userDetails.mobileNumber}</OTPMessage></OTPLongMessage>
      )
    } else {
      return (
        <OTPLongMessage>Enter the 6-digit code sent to your registered mobile no. <OTPMessage>{userDetails.mobileNumber}</OTPMessage>&nbsp; & email ID <OTPMessage>{userDetails.emailId}</OTPMessage></OTPLongMessage>
      )
    }
  }

  return (
    <VerifyOtpWrapper>
      {isOpen && (
        <StyledModal
          id="otp-verification-modal"
          onClose={() => onModalClose()}
          HeaderComponent={Header()}
          FooterComponent={Footer()}
          mode="normal"
          className={`otp-verification-modal `}
          wrapperClassname="otp-verification-modal-wrapper"
          contentClassname={`${isTransactionDone ? 'bank-payment' : 'login'}`}
        >
          <ModalContentContainer>
            {isTransactionDone && (
              <BankAccountWrapper>
                <DropdownWrapper>
                  <SelectDropdown
                    innerRef={ref}
                    value={formatValueForDropDown(formik.values.acctId)}
                    placeholder=""
                    options={userDetails.bankAccountNumbers}
                    required
                    shouldShowAsterisk={false}
                    disabled={(userDetails.bankAccountNumbers.length ==1)}
                    name="bank-account-dropdown"
                    onFocus={onFocus}
                    // onBlur={formik.handleBlur}
                    label={'Bank Account'}
                    onChange={(bankDetail) => onHandleChange('acctId', bankDetail.value)}
                    readOnly={(userDetails.bankAccountNumbers.length ==1)}
                    dropdownStyling={dropDownStyling}
                    className="dropdown-v2"
                  />
                  <ErrorMessage>
                    {isBankBalanceInsufficientForTransaction &&
                      CUSTOMER_SELECTS_BANK_ACCOUNT_WHICH_DOESNT_HAVE_ENOUGH_BALANCE}
                  </ErrorMessage>
                </DropdownWrapper>

                <InputWrapper>
                  <Input
                    label={'Balance'}
                    name="amount"
                    placeholder={formatMoney(userDetails.balance)}
                    disabled={true}
                    className="inputField-v2"
                    inputStylingProps={inputStylingProps}
                    innerRef={inputRef}
                  />
                </InputWrapper>
              </BankAccountWrapper>
            )}

            {isBankBalanceInsufficientForTransaction ? (
              ''
            ) : (
              <>
                <OTPMessageWrapper>
                  {OTPMessageContent()}
                </OTPMessageWrapper>
                <EnterOTPContainer>
                  <div>
                    {isMobile ? (
                    <StyledP2>{constants.ENTER_OTP}</StyledP2>
                    ):(
                      <P2>{constants.ENTER_OTP}</P2>
                    )}
                    
                  </div>
                  <Row>
                    <Col xs={12}>
                      <OTPpin isTransactionDone={isTransactionDone}>
                        {isTransactInvestJourney ? (
                          <div>
                            {isMobile? (
                          <StyledOTPInputMobile
                          
                            type="password"
                            innerRef={inputAmountRef}
                            onChange={handleOTPChange}
                            value={otp}
                          />
                            ):(
                              <StyledOTPInput
                          
                            type="password"
                            innerRef={inputAmountRef}
                            onChange={handleOTPChange}
                            value={otp}
                          />
                          )}
                          </div>
                        ) : (
                          <OtpInput
                            autoFocus
                            isNumberInput
                            length={6}
                            className="otpContainer"
                            inputClassName="otpInput"
                            onChangeOTP={(val: string) => setOTP(val)}
                            clearOtpField={clearOtpField}
                          />
                        )}
                      </OTPpin>
                    </Col>
                  </Row>
                </EnterOTPContainer>
              </>
            )}
          </ModalContentContainer>
        </StyledModal>
      )}
    </VerifyOtpWrapper>
  );
}

VerifyOTPModal.defaultProps = {
  showOtpField: true,
};

const StyledOTPInput = styled(Input)`
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

font-size: 18px;
padding-bottom: 10px;
letter-spacing: 16px;
text-align: center;
input[value]{
  text-align: center;
  }

  ${up('md')} {
    width: 60%;
    text-align: left;
  }
`;

const StyledOTPInputMobile = styled(Input)`
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }

  font-size: 18px;
  //padding-bottom: 10px;
  letter-spacing: 16px;
  text-align: center;
  input[value] {
    text-align: center;
  }

  ${up('md')} {
    width: 60%;
    text-align: left;
  }
`;

const StyledModal = styled(Modal)`
  &.modal-body {
    padding-bottom: 0;
  }
  &.otp-verification-modal-body {
    height: auto;
  }
  &.otp-verification-modal-wrapper {
    overflow: auto;
    padding-bottom: ${pxToRem(32)};
  }
  &.otp-verification-modal-content {
    ${up('md')} {
      max-height: 95%;
      top: 44%;
      left: calc(50% - 360px);
      margin-left: 0;
    }
  }
`;
const VerifyOtpWrapper = styled.div`
  .bank-payment {
    top: ${pxToRem(20)};
    ${up('md')} {
      top: 35%;
      min-height: ${pxToRem(440)};
    }
  }
`;

const ModalContentContainer = styled.div`
  ${up('md')} {
    min-height: ${pxToRem(160)};
  }
`;

const BankAccountWrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${up('md')} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

const DropdownWrapper = styled.div`
  width: 100%;
  ${up('md')} {
    width: ${pxToRem(276)};
  }
`;

const OTPMessageWrapper = styled.div`
  line-height: 1.3;
  ${up('sm')} {
    line-height: 1.2;
  }
`;
const EnterOTPContainer = styled.div`
  margin-top: ${pxToRem(32)};
  
`;

const FooterContainer = styled.div`
  width: 100%;
  ${up('md')} {
    text-align: end;
  }
`;

const OTPLongMessage = styled.span`
  color: ${(props) => props.theme.palette.grey3};
`;

const OTPMessage = styled.span`
  font-weight: bold;
  color: ${(props) => props.theme.palette.grey1};
`;
const OTPpin = styled.div<{ isTransactionDone: boolean }>`
  .border-bottom {
    border: none;
    border-bottom: ${(props) => `1px solid ${props.theme.palette.grey3}`};
    min-width: ${pxToRem(30)};
    color: ${(props) => `${props.theme.palette.grey3}`};
  }
  .otp-container-class {
    justify-content: space-between;
    height: ${pxToRem(48)};
    ${up('md')} {
      width: ${(props) => (props.isTransactionDone ? pxToRem(276) : '100%')};
    }
  }

  & .otpContainer {
    margin: ${pxToRem(12)} 0;
    display: flex;
    justify-content: space-between;
    ${up('md')} {
      width: ${(props) => (props.isTransactionDone ? pxToRem(300) : '100%')};
    }
  }

  & .otpInput {
    width: ${pxToRem(42)} !important;
    height: ${pxToRem(32)};
    margin-right: ${pxToRem(6)};
    font-size: ${pxToRem(8)};
    text-align: center;
    border: none;
    border-bottom: ${pxToRem(1)} solid rgba(0, 0, 0, 0.3);
    background: none;
  }
`;

const ResentCodeWrapper = styled.div`
  cursor: pointer;
`;
const StyledH6 = styled(H6)`
  color: #4a4a4a;
`;

const InputWrapper = styled.article<{ addLeftMargin?: boolean; disable?: boolean; reduceWidth?: boolean }>`
  margin-left: ${(props) => (props.addLeftMargin ? `${pxToRem(16)}` : '0')};
  display: ${(props) => (props.disable ? 'none' : '')};
  max-width: ${(props) => (props.reduceWidth ? `90%` : 'auto')};
  padding-top: ${pxToRem(4)};
  ${up('md')} {
    margin-left: 0;
    /* max-width: ${pxToRem(320)}; */
    padding-right: ${pxToRem(8)};
    min-width: 47%;
    padding-top: ${pxToRem(8)};
  }
`;

const ErrorMessage = styled(P2)`
  color: ${(props) => props.theme.palette.red1};
`;

const StyledP2 = styled(P2)`
margin-top: -20px;
`;